<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <!-- <template slot="car_type" slot-scope="params">
        <span v-if="params.params.car_type == 1">车头保险</span>
        <span v-if="params.params.car_type == 2">挂车保险</span>
      </template>
      <template slot="isdisplay" slot-scope="params">
        <MySwitch :data="params.params" :activeValue="`1`" :inactiveValue="`0`" @onToggle="toggleDisplay"></MySwitch>
      </template> -->
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'prepaid_type',
      getListUrl: 'rec',
      modalSubmitUrl: 'addedu',
      delUrl: 'del',
      breadcrumb: [
        { name: "系统设置" },
        { name: "预支款类型配置" },
      ],
      formCtrl: [
        {
          label: "",
          keyName: "name",
          placeholder: "请填写类型名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "car_type_name", label: "车种" },
        { keyName: "name", label: "预支款类型" },
        // { keyName: "user_name", label: "创建人" },
        // { keyName: "sort", label: "排序" },
        // { keyName: "is_view", label: "是否显示", slot: 'isdisplay' },
        // { keyName: "created_at", label: "添加时间" },
      ],
      allBtnWidth: '100px',
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // console.log(data)
            this.getItem(data)
            this.showDialog()
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '添加',
      viewMode: false,
      mform: {
        name: undefined,
        car_type_id: undefined
      },
      mrules: {
        car_type_id: [
          {
            required: true,
            message: '请选择车种',
            trigger: 'blur',
          }
        ],
        name: [
          {
            required: true,
            message: '请填写类型名称',
            trigger: 'blur',
          }
        ],
       
      },
      mformCtrl: [
        {
          label: "车种",
          keyName: "car_type_id",
          type: "select",
          options: [

          ],
        },
        {
          label: "预支款类型",
          keyName: "name",
          err: "请填写类型名称",
          type: "text",
        },

        //   label: "排序",
        //   keyName: "sort",
        //   err: "请填写排序",
        //   type: "number",
        //   unit: "数字越大排序越靠前",
        // },
        // {
        //   label: "是否显示",
        //   keyName: "is_view",
        //   type: "radio",
        //   options: [
        //     { label: '是', value: 1 },
        //     { label: '否', value: 0 },
        //   ],
        // },
      ],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = { ...v }
          obj.open = v.is_view + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id, is_view }) {
      console.log(id)
      let display = (is_view === 1 ? 0 : 1)
      let url = `${this.baseUrl}/addinsuranceauth `;
      const params = {
        userid: this.user.id,
        id,
        is_view: display
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    add() {
      delete this.mform.id
      this.mform = { name: undefined,car_type_id: undefined }
      this.title = '添加'
      this.showDialog()
    },
    getItem({ id, name, car_type_id}) {
      console.log(id, name, car_type_id)
      this.mform = { ...this.mform, id, name,car_type_id }
      
      this.title = '修改'
    },
    getOption() {
      let url = `prepaid_type/item`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, data }) => {
        if (msg) {
          console.log(data.car_type, 1111)
          this.mformCtrl.map((c) => {
            if (c.keyName == "car_type_id") {
              c.options = data.car_type.map((v) => {
                return {
                  label: v.name,
                  value: v.id,
                };
              });
            }
          });
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
      })
    },
  },
  mounted() {
    this.getOption();
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-form {
    padding-right: 0 !important;

    .el-form-item .el-form-item__content .content {
      display: block;

      .unit {
        line-height: 30px;
        margin: 0 auto;
        font-size: 12px;
        color: #FF6756;
      }
    }

    .el-input {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>